import { Injectable } from '@angular/core'
import { ManageUsersControllerService, RoleConstants } from 'app/shared/generated/generated'
import { BehaviorSubject } from 'rxjs'
import { PermissionService } from './permission.service'

@Injectable({
  providedIn: 'root',
})
export class ManageUsersService {
  constructor(
    private manageUsersControllerService: ManageUsersControllerService,
    private permissionService: PermissionService
  ) {
    this.getCountOfPendingUsers()
  }

  pendingUserCount$ = new BehaviorSubject<number>(0)

  getCountOfPendingUsers() {
    if (this.permissionService.doesUserHavePermission([RoleConstants.manageUsers])) {
      this.manageUsersControllerService.getCountOfPendingUsers_get().subscribe((data) => {
        if (data.succeeded) {
          this.pendingUserCount$.next(data.result)
        }
      })
    }
  }
}
